import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { InlineSvgDirective } from '../inline-svg/inline-svg.directive';

@NgModule({
  exports: [InlineSvgDirective],
  imports: [InlineSvgDirective],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class InlineSvgModule {}
